// https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3751215124/BSB+Enums

import {SecFEPermissionPartnerAppEnum} from './sec-f-e-permission-partner-app-enum';

export enum SecFEPermissionPartnerAppMappingEnum {
    PAU_CONTRACTS_CSP_EDIT = SecFEPermissionPartnerAppEnum.__PAU_CONTRACTS_CSP,
    PAU_CONTRACTS_CSP_READONLY = SecFEPermissionPartnerAppEnum.__PAU_CONTRACTS_CSP,

    PAU_CONTRACTS_CSP_CONNECTED = SecFEPermissionPartnerAppEnum.__PAU_CONTRACTS,
    __PAU_CONTRACTS_CSP = SecFEPermissionPartnerAppEnum.__PAU_CONTRACTS,
}
